<template>
  <a-layout-content class="p-all">
    <a-spin tip="Halaman sedang diproses!..." :spinning="loading.page">
      <a-card>
        <div slot="title">
          <span class="d-block">Surat Perintah Lembur</span>
        </div>
        <a-tag slot="extra" color="red" v-if="mode == 'revised'">{{ mode.toUpperCase() }}</a-tag>
        <a-tag slot="extra" color="green" v-else>{{ mode.toUpperCase() }}</a-tag>

        <a-row :gutter="{ xs: 0, lg: 8 }">
          <a-col :xs="24" :lg="12">
            <a-card title="Informasi">
              <a-form class="m-form" :form="form">
                <a-form-item label="Perintah dari">
                  <v-select mode="multiple" class="m-select-form-half" label="nama" :options="basedData.karyawan"
                    :reduce="item => item.tlc" placeholder="Pilih TLC yang memerintahkan" :filter-by="filterPelaksana"
                    autocomplete v-decorator="[
                      'commander',
                      {
                        rules: [{ required: true, }],
                      },
                    ]" @input="changecommander" :disabled="datasource.length > 0">
                    <template slot="option" slot-scope="option">
                      {{ option.tlc }} - {{ option.nama }}
                    </template>

                    <template slot="selected-option" slot-scope="option">
                      {{ option.tlc }} - {{ option.nama }}
                    </template>
                  </v-select>
                </a-form-item>
                <a-form-item label="Unit Kerja Pelaksana">
                  <v-select class="m-select-form-half" label="nama_dept" :options="basedData.department"
                    :reduce="item => item.id_dept" placeholder="Pilih Unit Kerja" :filter-by="filterDepartemen"
                    autocomplete v-decorator="[
                      'departemen',
                      {
                        rules: [{ required: true, }],
                      },
                    ]" @input="changedepartemen" :disabled="datasource.length > 0">
                    <template slot="option" slot-scope="option">
                      {{ option.nama_dept }}
                    </template>

                    <template slot="selected-option" slot-scope="option">
                      {{ option.nama_dept }}
                    </template>
                  </v-select>
                </a-form-item>
                <a-form-item label="TLC Pelaksana">
                  <v-select mode="multiple" class="m-select-form-half" label="nama" :options="basedData.karyawanAssignee"
                    :reduce="item => item.tlc" placeholder="Pilih TLC Pelaksana" :filter-by="filterPelaksana" autocomplete
                    multiple v-decorator="[
                      'assignee',
                      {
                        rules: [{ required: true, }],
                      },
                    ]" @input="changeassignee" :disabled="datasource.length > 0 || loading.assigne">
                    <template slot="option" slot-scope="option">
                      {{ option.tlc }} - {{ option.nama }}
                    </template>

                    <template slot="selected-option" slot-scope="option">
                      {{ option.tlc }} - {{ option.nama }}
                    </template>
                  </v-select>
                </a-form-item>
                <a-form-item class="m-remove">
                  <template slot="label">
                    Kode Proyek
                  </template>
                  <v-select class="m-select-form-half" :options="projectCode" label="nama_project"
                    :reduce="item => item.kode_project" placeholder="Pilih Kode Proyek" ref="fkode_proyek" v-decorator="[
                      'kode_proyek',
                      {
                        rules: [{ required: true, }],
                      },
                    ]" @input="changekodeproyek">
                  </v-select>
                </a-form-item>
                <a-form-item class="m-remove" label="Uraian Tugas">
                  <a-textarea placeholder="Isi Uraian Tugas ... " :rows="4" v-decorator="['uraian_tugas']" />
                </a-form-item>
              </a-form>
            </a-card>
          </a-col>
          <a-col :xs="24" :lg="12">
            <a-list itemLayout="vertical" :dataSource="datasource" :pagination="pagination" bordered
              :class="isMobile ? 'm-top' : ''">
              <a-row slot="header" type="flex" justify="space-between">
                <h3>Jadwal Pekerjaan</h3>
                <a-button type="primary" :disabled="loading.save" @click="handleTambahJadwal"><a-icon
                    type="plus" />&nbsp;Tambah</a-button>
              </a-row>
              <a-list-item slot="renderItem" slot-scope="item">
                <a-card style="padding:2px;">
                  <a-row :gutter="{ xs: 0, lg: 8 }">
                    <a-col :xs="24" :lg="6"><b>TLC</b></a-col><a-col :xs="24" :lg="18">: {{ item.assignee_dtl.toString()
                    }}</a-col>
                    <a-col :xs="24" :lg="6"><b>Tanggal</b></a-col><a-col :xs="24" :lg="18">: {{ item.date }}</a-col>
                    <a-col :xs="24" :lg="6"><b>Estimasi Waktu</b></a-col><a-col :xs="24" :lg="18">: {{ item.start_time }}
                      s.d
                      {{ item.end_time }}</a-col>
                    <a-col :xs="24" :lg="6"><b>Lokasi</b></a-col><a-col :xs="24" :lg="18">: {{ item.lokasi_lembur
                    }}</a-col>
                  </a-row>
                  <div slot="actions">
                    <a-button-group>
                      <a-button size="small" type="default" icon="edit" @click="ubahDetil(item.key)">Ubah</a-button>
                      <a-button size="small" type="danger" icon="delete" @click="hapusDetil(item.key)">Hapus</a-button>
                    </a-button-group>
                  </div>
                </a-card>
              </a-list-item>
            </a-list>
          </a-col>
        </a-row>
        <div slot="actions" style="width:100%;display: flex;justify-content: space-between;">
          <div>&nbsp;</div>
          <a-button type="primary" :disabled="datasource.length == 0" :loading="loading.save"
            @click="handleSimpanSPL">Simpan</a-button>
        </div>
        <!-- :disabled="datasource.length == 0" -->
      </a-card>
    </a-spin>
    <a-modal v-model="mjadwal" v-if="this.mjadwal" @cancel="handleCanceljadwal">
      <span slot="title">
        <a-icon type="form" />&nbsp;Jadwal Pekerjaan
      </span>

      <a-form class="m-form" :form="formjdwal">
        <a-form-item label="TLC">
          <a-select mode="multiple" placeholder="Please select" v-decorator="[
            'assignee_dtl',
            {
              rules: [{ required: true, }], initialValue: datamodal.assignee_dtl,
            },
          ]" ref="assignee_dtl">
            <a-select-option showSearch v-for="user in assignee" :key="user.tlc">{{ user.tlc }} - {{ user.nama
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-row :gutter="{ xs: 0, lg: 8 }">
          <a-col :xs="24" :lg="12">
            <a-form-item label="Tanggal">
              <a-date-picker placeholder="Pilih Tanggal" :format="getDefaultDateFormat" v-decorator="[
                'date',
                {
                  rules: [{ required: true }], initialValue: datamodal.date,
                },
              ]" class="w-full" />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :lg="12">
            <div class="ant-row ant-form-item">
              <div class="ant-col ant-form-item-label">
                <label for="tgl_document" title="Tanggal" class="ant-form-item-required">Estimasi Waktu</label>
              </div>
              <a-row :gutter="{ xs: 0, lg: 8 }">
                <a-col :xs="24" :lg="11">
                  <a-form-item>
                    <a-time-picker v-decorator="[
                      'start_time',
                      {
                        rules: [{ required: true }], initialValue: datamodal.start_time,
                      },
                    ]" format="HH:mm" placeholder="Awal" class="w-full" />
                  </a-form-item>
                </a-col>
                <a-col :xs="24" :lg="2" style="text-align: center;">
                  <span>~</span>
                </a-col>
                <a-col :xs="24" :lg="11">
                  <a-form-item>
                    <a-time-picker v-decorator="[
                      'end_time',
                      {
                        rules: [{ required: true }], initialValue: datamodal.end_time,
                      },
                    ]" format="HH:mm" placeholder="Akhir" class="w-full" />
                  </a-form-item>
                </a-col>
              </a-row>
            </div>
          </a-col>
        </a-row>
        <!-- :validateStatus="prefixLength.validateStatus" -->
        <!-- :help="prefixLength.errorMsg" -->
        <a-form-item label="Lokasi Lembur">
          <a-textarea placeholder="Isi Lokasi Lembur ... " :autoSize="{ minRows: 2, maxRows: 3 }"
            v-decorator="['lokasi_lembur', { rules: [{ required: false }], initialValue: datamodal.lokasi_lembur }]" />
        </a-form-item>
      </a-form>
      <div slot="footer" class="w-full">
        <a-button type="primary" @click="handleSimpanjadwal">Simpan</a-button>
      </div>
    </a-modal>
  </a-layout-content>
</template>

<script>
import axios from "axios";
import { mapGetters, } from "vuex";
import moment from "moment";
import _ from "lodash";

export default {
  name: "create_SPL",
  props: ["id"],
  components: {},
  data() {
    return {
      mode: '',
      datasource: [],
      pagination: {
        onChange: page => {
          this.pagination.page = page;
        },
        page: 1,
        pageSize: 3,
        size: "default"
      },
      basedData: [],
      mjadwal: false,
      assignee: [],
      datamodal: [],
      loading: {
        save: false,
        page: false,
        assigne: false
      },
      kode_proyek: null,
      initialAsignTLC: [],
      filterPelaksana: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.nama.toLowerCase().indexOf(temp) > -1 ||
          option.tlc.toLowerCase().indexOf(temp) > -1
      },
      filterDepartemen: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.nama_dept.toLowerCase().indexOf(temp) > -1
      },
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formjdwal = this.$form.createForm(this);
    this.$store.dispatch("FETCH_KARYAWAN");
  },
  created() {
  },
  mounted() {
    this.mode = this.$route.meta.isCreate ? 'Create' : 'Edit';
    this.fetchData();
    if (this.mode == 'Edit')
      this.fetchEditData();
    Event.$on("confirmMessageSave", this.handleProcesSimpanSPL);

  },
  beforeDestroy() {
    Event.$off("confirmMessageSave", this.handleProcesSimpanSPL);
  },
  watch: {},
  computed: {
    ...mapGetters([
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate"
    ]),
    projectCode() {
      let output = this.basedData.kode_project;
      return output;
    },
  },
  methods: {
    moment,
    async fetchEditData() {
      this.loading.page = true
      const spl = await axios.get(this.$serviceUrl + "spl", {
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        },
        params: {
          id_manifest: this.id
        }
      });

      Promise.all([spl]).then(response => {
        this.datasource = response[0].data.detail;
        for (let i = 0; i < this.datasource.length; i++) {
          this.datasource[i]['key'] = i
          this.datasource[i]['assignee_dtl'] = this.datasource[i].pelaksana
          this.datasource[i]['lokasi_lembur'] = this.datasource[i].lokasi
          this.datasource[i]['start_time'] = moment(this.datasource[i].start_time).format("HH:mm")
          this.datasource[i]['end_time'] = moment(this.datasource[i].end_time).format("HH:mm")
        }
        this.form.setFieldsValue({
          commander: response[0].data.header[0].commander,
          assignee: response[0].data.header[0].pelaksana.split(','),
          kode_proyek: response[0].data.header[0].c_proyek,
          uraian_tugas: response[0].data.header[0].uraian,
          departemen: response[0].data.header[0].departemen_id
        })
        this.loading.page = false
      });
    },
    async fetchData() {
      this.loading.page = true

      const mstr = await axios.get(this.$serviceUrl + "rekap_alokasi/master", {
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        },
        params: {
          tlc: this.getAuth.username
        }
      });

      const mstr2 = await axios.get(this.$serviceUrl + "spl/create", {
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        },
        params: {
          tlc: this.getAuth.username
        }
      });

      Promise.all([mstr, mstr2]).then(response => {
        this.basedData = response[0].data;
        this.basedData['department'] = response[1].data.Departemen
        this.basedData['karyawan'] = response[1].data.karyawan
        this.basedData['karyawanOri'] = response[1].data.karyawan
        this.basedData['karyawanAssignee'] = response[1].data.karyawan
        this.loading.page = false
      });
    },
    handleTambahJadwal() {
      this.form.validateFields((err, val) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        console.log(val.assignee, val.commander, _.findIndex(val.assignee, (e) => { return e == val.commander }))
        if (_.findIndex(val.assignee, (e) => { return e == val.commander }) >= 0) {
          this.displayMessageValue('error-basic', 'TLC Pelaksana Tidak Boleh ada dari TLC Pemerintah SPL!');
          return
        }

        this.datamodal = [],
          this.assignee = [];
        const tassign = this.form.getFieldValue("assignee");
        if (tassign == null) {
          this.displayMessageValue('error-basic', 'Kepada TLC tidak boleh kosong!');
        } else {
          this.mjadwal = true;
          for (let i = 0; i < tassign.length; i++) {
            this.assignee.push(
              this.basedData.karyawanOri.filter(
                (item) => item.tlc == tassign[i])[0]
            )
          }
        }
      })
    },
    handleCanceljadwal() {

    },
    handleSimpanjadwal() {
      this.formjdwal.validateFields((err, values) => {
        if (err) {
          this.displayMessage('uncompleteInput');
          return;
        }

        if (this.datamodal.length == 0) {
          let tempdata = {
            key: this.datasource.length,
            date: moment(values.date).format(this.getStandartFormatDate),
            start_time: moment(values.start_time).format("HH:mm"),
            end_time: moment(values.end_time).format("HH:mm"),
            assignee_dtl: values.assignee_dtl,
            lokasi_lembur: values.lokasi_lembur
          }
          this.datasource.push(tempdata)
          this.displayMessage('success-add')
          this.formjdwal.resetFields()
          this.$refs.assignee_dtl.focus()
        } else {
          let index = _.findIndex(this.datasource, (e) => {
            return e.key == this.datamodal.key;
          });
          this.datasource[index].date = values.date.format(this.getStandartFormatDate);
          this.datasource[index].start_time = moment(values.start_time).format("HH:mm");
          this.datasource[index].end_time = moment(values.end_time).format("HH:mm");
          this.datasource[index].assignee_dtl = values.assignee_dtl.toString();
          this.datasource[index].lokasi_lembur = values.lokasi_lembur;

          this.mjadwal = false;
          this.datamodal = []
          this.displayMessage('success-edit')
        }
      });
    },
    handleSimpanSPL() {
      this.confirmMessageValue('confirm-save', true)
    },
    handleProcesSimpanSPL() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage('uncompleteInput');
          return;
        }
        this.loading.save = true;

        let postData = new FormData();

        if (this.mode == "Edit") {
          postData.append("spl_id", this.id);
        }

        postData.append("assignee", values.assignee.toString());
        postData.append("kode_proyek", values.kode_proyek);
        postData.append("uraian_tugas", values.uraian_tugas ? values.uraian_tugas : "");
        postData.append("commander", values.commander);
        postData.append("departemen", values.departemen);

        this.datasource.forEach(element => {
          postData.append("date[]", element.date);
          postData.append("start_time[]", element.date + " " + element.start_time + ":00");
          postData.append("end_time[]", element.date + " " + element.end_time + ":00");
          postData.append("assignee_dtl[]", element.assignee_dtl.toString());
          postData.append("lokasi_lembur[]", element.lokasi_lembur);
        });

        axios({
          method: "post",
          url: this.$serviceUrl + (this.mode == "Edit" ? "Spl/edit" : "Spl"),
          processData: false,
          data: postData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": this.getAuth.apikey
          }
        })
          .then(() => {
            this.loading.save = false;
            this.displayMessage("success-save")
            this.$router.push({
              name: "spl",
            });
          })
          .catch(err => {
            err = Object.assign({}, err.response)
            if (err.data.message) {
              this.displayMessageValue("error-basic", err.data.message);
            } else {
              let response = Object.assign({}, err.response);
              this.displayMessageValue("error-other", response);
            }
            this.loading.save = false;
          });
      });
    },
    changekodeproyek(val) {
      this.form.setFieldsValue({
        kode_proyek: val,
      })
    },
    changeassignee(val) {
      this.form.setFieldsValue({
        assignee: val,
      })
    },
    changedepartemen(val) {
      this.form.setFieldsValue({
        departemen: val,
        assignee: null
      })
      this.basedData.karyawanAssignee = _.filter(this.basedData.karyawanOri, (el) => el.id_departemen == val)
    },
    changecommander(val) {
      this.form.setFieldsValue({
        commander: val,
      })
    },
    hapusDetil(key) {
      this.datasource = _.filter(this.datasource, (item) => item.key != key);
    },
    ubahDetil(key) {
      this.assignee = [];
      const tassign = this.form.getFieldValue("assignee");
      if (tassign == null) {
        this.displayMessageValue('error-basic', 'Kepada TLC tidak boleh kosong!');
      } else {
        for (let i = 0; i < tassign.length; i++) {
          this.assignee.push(
            this.basedData.karyawanOri.filter(
              (item) => item.tlc == tassign[i])[0]
          )
        }

        let tempfilt = _.filter(this.datasource, (item) => item.key == key);
        this.datamodal = {
          key: key,
          assignee_dtl: tempfilt[0].assignee_dtl,
          date: moment(tempfilt[0].date, this.getStandartFormatDate),
          start_time: moment(tempfilt[0].date + " " + tempfilt[0].start_time + ":00"),
          end_time: moment(tempfilt[0].date + " " + tempfilt[0].end_time + ":00"),
          lokasi_lembur: tempfilt[0].lokasi_lembur
        }
        this.mjadwal = true;
      }
    }
  }
};
</script>

<style lang="less">
.m-select-form-half>.vs__dropdown-toggle {
  height: auto;
}

.ant-list-bordered .ant-list-item {
  padding: 2px;
}

.ant-list-item {
  padding: 2px 0;
}
</style>